export abstract class BaseUrls {
    /**
     * Base Url is an abstract class containing definations of all urls.
     *
     * Urls can be of different cloud providers/ local setup url.
     * These sub classes need to extend this `BaseUrls` class
     */


    // Auth Server Host
    adminHost: string;
    retailHost: string;
    authServerHost: string;
    restServerHost: string;
    profileServerHost: string;
    brokerServerHost: string;
    flaskServerHost: string;
    fastApiServerHost: string;
    optionCalculatorServer: string;
    uGateWayURL: string;
    uGateWayLogin: string;
    mastertrustLogin: string;
    algoServerHost: string;
    affiliateHost: string;
    aiAssistantServer: string;
    ekycServer: string;
    aiRecommendationServer: string;
    analyticsServer: string;

    getPaymentStaticData: string;

    // Phone auth urls
    phoneLogin: string;
    validateMobileOTP: string;
    resendOTPLink: string;
    verifyPhone: string;
    resendPhoneLink: string;

    // Auth Urls
    login: string;
    logoutUser: string;
    cancelConnectBroker: string;
    fogot: string;
    lastSession: string;
    
    isEmailRegistered: string;
    isPhoneRegistered: string;
    updateUserDetails: string;
    verifyInitialDetailsEmailOtp: string;
    resendInitialDetailsOtp: string;

    signUpUrl: string;
    verifyEmail: string;
    validateOTP: string;
    geolocationAPIUrl: string;

    resetPassword: string;
    changePassword: string;

    verifyMPIN: string;
    setMPIN: string;
    forgotMpin: string;

    otp: string;
    consentToken: string;

    //UT-1093 email change
    sendEmailOtp: string;
    resendEmailOtp: string;
    verifyEmailOtp: string;

    socialLoginInit: string;
    socialLoginCallBack: string;

    passwordPolicy: string;
    logoutSessions: string;
    isSessionLoggedIn: string;

    // funds
    payin: string;
    status: string;
    fetchMargin: string;
    transactionHistory: string;
    marginBlocked: string;

    // swastika margin
    fetchSwastikaMargin: string;

    //mastertrust margin
    fetchMastertrustMargin: string;

    // Static Data Urls
    scripMaster: string;
    indicesMaster: string;
    symbolInfoMaster: string;
    userManualLink: string;

    // Social
    getTweets: string;
    getNews: string;

    // Market Watch Urls
    marketWatchList: string;
    marketWatchItems: string;
    staticData: string;
    symbolData: string;
    ohlcFirstFetch: string;

    // AdminUrls
    plans: string;
    pricing: string;
    defaultPricing: string;
    timeConfig: string;
    timeConfigReset: string;
    ums: string;
    activeUsers: string;
    supportedBrokers: string;
    clientsBrokers: string;
    inbuiltAlgoList: string;
    toggleAlgoProvider: string;

    brokerSession: string;
    fastApiHost: string;
    portfolioOrigin: string;

    // ProfileUrls
    picture: string;
    profilePlans: string;
    activeSessions: string;
    brokerPlanFailure: string;
    recurringSuccess: string;

    // Plans & Payemnts URL
    details: string;
    updateDetails: string;
    planInfo: string;
    paymentsServerUrl: string;
    plansCatalog: string;
    plansSubscribe: string;
    plansCancel: string;
    plansToggleAutopay: string;
    plansTransactionHistory: string;
    planSubscriptionStatus: string;
    signedRedirectUrl: string;
    walletUrl: string;

    // BrokerUrls
    brokerFormSettings: string;
    brokerSettings: string;

    // Retail urls
    checkPermissions: string;

    // BooksUrls
    getOrderBook: string;
    getTradeBook: string;
    getPositionBook: string;

    // Strategy URLS
    algoCreationUpdating: string;
    loadStrategy: string;
    listAlgos: string;
    listActiveCompletedAlgos: string;
    algoExecution: string;
    updateAlgoState: string;
    updateStateForAllAlgos: string;
    indicatorList: string;
    paramsDetection: string;
    timeConfiguration: string;

    //Net User Margin Url.
    netUserProfit: string;
    strategyWisePnl: string;

    //orders
    placeOrder: string;
    orderSocket: string;

    // backtest
    backTest: string;
    backTestIterations: string;
    backTestCharts: string;


    // resend verify link
    resendLink: string;

    // Config
    serverConfig: string;

    //download pdf
    exportReportAsPdf: string;
    // Cache
    getCache: string;
    setCache: string;

    // Pay-off Curve
    getGreeks: string;
    payOffCurve: string;
    getOptionPrice: string;
    getIV: string;

    // PORTFOLIO
    portfolioUrl: string;

    //accept portfolio
    acceptPortfolio: string;

    // Portfolio Marketplace URLs
    portfolioMarketPlace: string;
    portfolioSubscribe: string;
    portfolioBookmark: string;

    getCreatedPortfolio: string;
    getPortfolioFromStatus: string;
    getSubscribedPortfolio: string;
    getDeployedPortfolio: string;
    getClientPortfolioDetails: string;
    getBookmarkedPortfolio: string;
    getSharedPortfolio: string;
    updateBulkPortfolioState: string;

    // Portfolio Execution URLs
    updatePortfolioState: string;
    checkPortfolioRegulation: string;
    updatePortfolioStateAdmin: string;
    updateCopyPortfolioVersion: string;
    runPortfolio: string;
    backtestState: string;
    squareOffPortfolio: string;

    // Panic Control URL
    panicControl: string;
    panicControlAdmin: string;

    // Resume bulk portfolios
    resumePortfolios: string;

    //auto Deployment Portfolios
    autoDeployPortfolios: string;

    // Portfolio CRUD URLs
    createPortfolio: string;
    updatePortfolio: string;
    getPortfolioDetails: string;
    updateExitParams: string
    getExitParams: string
    resetExitParams: string
    copyPortfolio: string;
    updateMultiplier: string;


    // Margin Calculator
    calculateMargin: string;
    calculatePeakMargin: string;
    calculateRequiredMargin: string;

    // Plans and pricing
    subscribePlan: string;
    cancelPlan: string;
    upgradePlan: string;
    verifyVPA: string;
    estimate: string;
    immediateCancel: string;
    toggleAutoPay: string;
    getCouponById: string;
    subscribedCount: string;
    listPromotionPlans: string;
    getPlanApproval: string;


    // Notifications
    createNotification: string;
    updateNotification: string;
    markNotifiactionAsRead: string;
    updateNotificationPreference: string;

    // Transaction History
    getTransactionHistory: string;
    downloadInvoice: string;

    // Connect to broker
    getMapping: string;

    // Affiliate
    affiliateHostLogin: string;
    affiliateProfile: string;
    affiliateLeads: string;
    affiliateFunds: string;
    forgotPasswordAffiliate: string;
    affiliateMarginBlocked: string;
    dealerClientsList: string;

    // Global Exit Parameters
    globalExitUrl: string;
    globalExitStatus: string;

    // share
    listShareClients: string;
    shareWithClients: string;

    // One AI
    getConversations: string;
    getConversationByID: string;
    toggleStarThread: string;
    deleteConversation: string;
    createNewConversation: string;
    sendMessage: string;
    stopResponse: string;
    validateYml: string;
    saveYmlPortfolio: string;
    aiSocketStream:string;
    aiCreditUsage: string;
    portfolioVersionsUrl: string;

    // AI Recommendation
    aiRecommendedOriginals: string;
    aiBacktest: string;
    aiBacktestStatus: string;
    sendFeedback: string;

    // Screener
    screenerUrl: string;
    getRecentScreenersUrl: string;
    getStarredScreenersUrl: string;
    getScreenerUrl: string;
    toggleStarScreenerUrl: string;
    deleteScreenerUrl: string;

    // Market Watch
    marketWatchUrl: string;
    singleSymbolData: string;
    setCacheUrl: string;
    getCacheUrl: string;
    marketWatchUpdate: string;

    // ekyc
    fnoEnable: string;

    // retain multiplier
    retainMultiplier: string;  
    setRetainMultiplier: string;

    //operator
    operatorServer: string;
    operatorDashboardHost: string;
    loginOperator: string;
    loginClients: string;
    logoutClients: string;
    uploadOperatorClientMap: string;
    getClientDeployedPortfolio: string;
    getClietInfo: string;
    getOperatorClientDetails: string;
    getClientsDetails: string;
    uploadOperatorStrategyMultiplierMap: string;
    squareOffPortfolioState: string;
    getOperatorClientMappings: string;
    assignOperatorClients: string;
    makeClientOperator: string;
    adminLoginOperator: string;
    isLastSession: string;
    modifyRunningPortfolio: string;
    updateSharePortfolioStatus: string;
    clientBooks: string;
    getClientMarginDetails: string;
    getSelectedStrategies: string;
    updateSelectedStrategies: string;

    //Multi Broker Specific
    multiBrokerAuthServerHost: string;
    multiBrokerEmailPhoneLogin: string;
    validateUsername: string;
    multiBrokerVerifyOTP: string;
    multiBrokerRefreshToken: string;
    getBrokers: string;
    getAvailableBrokers: string;
    getConnectedBrokers: string;
    getAlgoSpaces: string;
    mapAlgoSpace: string;
    loginBroker: string;
    directLogin: string;
    userLogout: string;
    multiBrokerResendOTP: string;
    getBrokerMarginBlocked: string;
    getBrokerPeakMargin: string;

    constructor(
        authHost: string,
        restServerHost: string,
        algoServerHost: string,
        flaskServerHost: string,
        fastApiServerHost: string,
        optionCalculatorServer: string,
        uGateWay: string,
        aiAssistantServer: string,
        ekycServer: string,
        operatorServer: string,
        aiRecommendationServer: string,
        aiAnalyticsServer: string,
    ) {
        this.authServerHost = authHost;
        this.restServerHost = restServerHost;
        this.algoServerHost = algoServerHost;
        this.flaskServerHost = flaskServerHost;
        this.fastApiServerHost = fastApiServerHost;
        this.optionCalculatorServer = optionCalculatorServer;
        this.uGateWayURL = uGateWay;
        this.aiAssistantServer = aiAssistantServer
        this.ekycServer = ekycServer;
        this.operatorServer = operatorServer;
        this.aiRecommendationServer = aiRecommendationServer;
        this.analyticsServer = aiAnalyticsServer;
        this.initUrls();
    }

    /**
     * Need to implement `initUrls` method in subclasses.
     */
    abstract initUrls(): void;

    abstract getBrokerLogoutURL(broker: string): string;
    abstract getMultiBrokerSocialLoginInitURL(provider: string): string;
    abstract getMultiBrokerLoginInitURL(provider: string): string;
    abstract getMultiBrokerSocialLoginCallback(provider: string): string;
}
